import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getNotificationApprovalUsers } from 'store/actions';

const initialState = {
    users: [],
    error: null,
    loading: false
};

const notificationApprovalUserStart = (state, action) => {
    /*
    console.log('notificationLoadStart');
    console.log(state);
    console.log(action);
    */
    return updateObject( state, { error: null, loading: true } );
}

const notificationApprovalUserSuccess = (state, action) => {
    //console.log('notificationApprovalUserSuccess');
    //console.log(state);
    //console.log(action);

    /*
    // convert notification object to indexed array
    const notifications = [];
    let index = 0;
    // process notifications object
    for(let key in action.notifications) {
        // add notification to buffer
        notifications[index] = action.notifications[key];
        // set element type in notifications
        notifications[index]['elementType'] = 'notification';
        // increment index
        index++;
    }
    */
    /*
    console.log(typeof notifications);
    console.log(notifications);
    console.log(notifications.length);
    */

    return updateObject( state, {
        users: action.users,
        loading: false
    });
}

const notificationApprovalUserFail = (state, action) => {
    /*
    console.log('notificationLoadFail');
    console.log(state);
    console.log(action);
    */
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NOTIFICATION_APPROVAL_USER_START: return notificationApprovalUserStart(state, action);
        case actionTypes.NOTIFICATION_APPROVAL_USER_SUCCESS: return notificationApprovalUserSuccess(state, action);
        case actionTypes.NOTIFICATION_APPROVAL_USER_FAIL: return notificationApprovalUserFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
